export const baseURL = "/HubsLogbook";
export const APPLICATION_ID = 15